export enum OrderTransferRecordState {
  IN_PROGRESS,
  ACCEPTANCE,
  ABORT_REJECT,
  TRANSFERED,
}
